import { ReelSize } from '../../models/ReelSize';

export const getReelSizeTotal = (quantity: number, reelSize: ReelSize) =>
  quantity * getTotalPerReelSize(reelSize);

export const getTotalPerReelSize = (reelSize: ReelSize) =>
  reelSize.deposit * (1 - reelSize.serviceFee);
